import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmLiveConversationsRoute: InvariantJiraRoute = {
	name: 'csm-live-conversations',
	path: '/jira/customer-service-management/projects/:projectKey/conversations/:issueKey?',
	exact: true,
};
